import React from 'react';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { Illustrations, WpIllustration } from 'Wpds/components/illustration';

// Styles
import './UserProfileEmptyState.scss';

type Props = {
  title: string;
  description?: string;
  image: Illustrations;
};

const UserProfileEmptyState = ({ title, description, image }: Props) => {
  const baseClassName = 'UserProfileEmptyState';
  return (
    <WpContainer>
      <WpContainerBody>
        <div className={baseClassName}>
          <WpIllustration className={`${baseClassName}__image`} src={image} alt="title" />
          <div className={`${baseClassName}__title_wrapper`}>
            <h5 className={`${baseClassName}__title`}>{title}</h5>
            {description && <p className={`${baseClassName}__description`}>{description}</p>}
          </div>
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default UserProfileEmptyState;
